import { createAsyncThunk } from "@reduxjs/toolkit";
import { logoutUser } from "./authThunks";

const API_BASE = process.env.REACT_APP_API_BASE;
const API_KEY = process.env.REACT_APP_API_KEY;
/**
 * fetch all Vendor entries
 */
export const fetchVendorItems = createAsyncThunk(
  "vendor/fetchItems",
  async (sector, thunkAPI) => {
    const res = await fetch(`${API_BASE}/api/vendor?vendor_profile_status=Active`, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": API_KEY,
      },
    });

    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);
export const SearchVendorItems = createAsyncThunk(
  "vendor/searchItems",
  async (
    { companyName, sortOrder, selectedIndustry, rewardMin, rewardMax },
    thunkAPI
  ) => {
    const res = await fetch(
      `${API_BASE}/api/vendor/search?search=${companyName}&sortBy=company_name&vendor_profile_status=Active&sortOrder=${sortOrder}&reward_min=${rewardMin}&reward_max=${rewardMax}&vendor_industry_sector=${selectedIndustry}`,
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": API_KEY,
        },
      }
    );

    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);

export const fetchVendorById = createAsyncThunk(
  "vendor/fetchById",
  async (vendorId, thunkAPI) => {
    const res = await fetch(
      `${API_BASE}/api/vendor/getByParam?_id=${vendorId}`,
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": API_KEY,
        },
      }
    );
    // if (res.status === 401) {
    //   thunkAPI.dispatch(logoutUser());
    //   window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
    //   return thunkAPI.rejectWithValue("Unauthorized");
    // }
    const json = await res.json();
    if (!res.ok) {
      throw new Error(json?.message || "Failed to fetch vendor by ID");
    }

    return json;
  }
);

export const fetchVendorByEmail = createAsyncThunk(
  "vendor/fetchById",
  async (email, thunkAPI) => {
    const res = await fetch(
      `${API_BASE}/api/vendor/getByParam?vendor_work_email=${email}`,
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": API_KEY,
        },
      }
    );

    // if (res.status === 401) {
    //   thunkAPI.dispatch(logoutUser());
    //   window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
    //   return thunkAPI.rejectWithValue("Unauthorized");
    // }

    const json = await res.json();
    if (!res.ok) {
      throw new Error(json?.message || "Failed to fetch vendor by ID");
    }

    return json;
  }
);

export const fetchVendorsBySector = createAsyncThunk(
  "vendor/fetchBySector",
  async (sector, thunkAPI) => {
    const res = await fetch(
      `${API_BASE}/api/vendor/?vendor_industry_sector=${sector}`,
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": API_KEY,
        },
      }
    );

    // if (res.status === 401) {
    //   thunkAPI.dispatch(logoutUser());
    //   window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
    //   return thunkAPI.rejectWithValue("Unauthorized");
    // }
    const json = await res.json();
    if (!res.ok) {
      throw new Error(json?.message || "Failed to fetch vendors by sector");
    }

    return json;
  }
);

export const uploadImage = createAsyncThunk(
  "vendorsonhome/uploadImage",
  async (data, thunkAPI) => {
    const formData = new FormData();
    formData.append("file", data);
    const res = await fetch(`${API_BASE}/api/upload`, {
      method: "POST",
      credentials: "include",
      headers: {
        "x-user-role": "partner",
      },
      body: formData,
    });
    if (res.status === 401) {
      thunkAPI.dispatch(logoutUser());
      window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);

export const updateVendorsonhome = createAsyncThunk(
  "vendor/updateItems",
  async (data, thunkAPI) => {
    const body = JSON.stringify(data);
    const res = await fetch(`${API_BASE}/api/vendor?_id=${data._id}`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "partner",
      },
      body: body,
    });
    if (res.status === 401) {
      thunkAPI.dispatch(logoutUser());
      window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);
